export default "__VITE_ASSET__OJRTcrBF__"